import React from 'react';
import { useWindowWidth } from '../../helpers';
import { styled } from "../../stitches.config";
import TeamImageGrid from '../components/Career/TeamImageGrid';
import Contacts from '../components/Career/Contacts';
import Faq from '../components/Career/Faq';
import { body, h1, h2, h4, p } from '../commonStyles/Fonts';
import dotmap from '../../assets/img/natemat/career/dotmap.png';
import SimpleCards from '../components/Tip/SimpleCards';
import IconCard from '../components/Career/IconCard';
import MailButton from '../components/Career/MailButton';
import HeroIcon from '../../assets/img/natemat/tip/tip_hero_icon.png';
import { ReactComponent as ProsteIcon } from '../../assets/img/natemat/tip/proste_i_wygodne.svg?react';
import { ReactComponent as AutorIcon } from '../../assets/img/natemat/tip/prosto_do_autora.svg?react';
import { ReactComponent as PrywatnoscIcon } from '../../assets/img/natemat/tip/prywatnosc.svg?react';
import { ReactComponent as CircleIcon } from '../../assets/img/natemat/tip/dots.svg?react';
import Footer from "../components/Footer"

const ReaderTipPage = () => {

    const SimpleCardsItems = [
        {
            icon: <ProsteIcon />,
            title: 'Proste i wygodne',
            text: 'Możesz zostawić napiwek z poziomu konkretnej treści -  artykułu, podcastu czy wideo, albo wchodząc na profil autora. Wystarczy, że wybierzesz kwotę i zapłacisz.'
        },
        {
            icon: <AutorIcon />,
            title: 'Prosto do autora',
            text: 'Cała kwota trafia prosto na konto autora. NaTemat nie pobiera żadnej prowizji, 100% wpłaconych środków leci do autora.'
        },
        {
            icon: <PrywatnoscIcon />,
            title: 'Prywatność',
            text: 'Napiwki są anonimowe, ale dla chętnych jest możliwość zostawienia wiadomości do autora.'
        },
    ]

    const faqcontent = [
        {
            title: 'Skąd pomysł na dodanie funkcji zostawiania napiwku?',
            text: '"Tip the journalist" to innowacyjne podejście do tematu płacenia za treści w internecie. Mimo wszystko Polacy robią to raczej niechętnie, w zdecydowanej większości nie chcą płacić za dostęp do informacji, a często i wspierać całego medium. Rozumiemy to. Dlatego my stawiamy na zupełnie inną relację na linii czytelnik-autor. Stworzyliśmy system "Tip the jorunalist", który opiera się na popularnej zasadzie dawania napiwków. Dziś tipujemy wszystkich, od dostawcy jedzenia, przez kelnera, po kosmetyczki. Dlaczego więc napiwku nie może dostać dziennikarz za profesjonalnie napisany artykuł, podcast lub wideo? Zwłaszcza że cała kwota napiwku trafi do niego jako dodatek, więc mowa tutaj naprawdę o faktycznym podziękowaniu za materiał dziennikarski.',
        },
        {
            title: 'Czy cała suma przelana jako napiwek trafia do autora?',
            text: 'Napiwki pomniejszone o opłatę manipulacyjną dla operatora płatności trafiają w całości do autorów. Redakcja nie pobiera z tego tytułu żadnej prowizji.',
        },
        {
            title: 'Jaka jest polityka zostawiania napiwku?',
            text: 'Dziś maksymalne uznanie, jakie dziennikarz może dostać od czytelnika, to mail z podziękowaniem. To miłe i bardzo cenione przez dziennikarzy, ale tę relację można wnieść na inny poziom. Skoro żyjemy w kulturze tipowania za dobrze wykonaną usługę, to dlaczego napiwków nie mogą dostawać dziennikarze za swój materiał? Wierzymy, że zbudujemy w ten sposób zupełnie nową więź na linii czytelnik- autor.Nie zmuszamy do długotrwałych subskrypcji za konkretną kwotę dla całego medium.Dajemy możliwość docenienia konkretnego dziennikarza znanego z twarzy i nazwiska oraz zdjęcia za konkretny materiał, który czytelnik właśnie przeczytał, przesłuchał lub obejrzał. Kwota wsparcia będzie dowolna i trafi do konkretnego autora. W ten sposób tworzymy nowy model, który nie posiada barier zazwyczaj zniechęcających internautów. Kwota nie ma znaczenia. Może to być nawet symboliczna złotówka.',
        },
        {
            title: 'Z jakich płatności mogę skorzystać zostawiając napiwek? ',
            text: 'Napiwki można zostawić przez system Przelewy24, który umożliwia płatności BLIK oraz szybkie przelewy z najpopularniejszych banków.',
        },
    ]

    const isDesktop = useWindowWidth() > 992;

    return (
        <>
            <Container>
                <Hero>
                    <OrangeCircle />
                    <HeroHeader>
                        <img src={HeroIcon} alt="Tip hero logo" />
                        <h1 className={h1()}>Powiedz naszym autorom <OrangeSpan>"dziękuję"</OrangeSpan> za dobry materiał dziennikarski</h1>
                    </HeroHeader>
                    <HeroMessages>
                        <TextTile><p className={body()}>Cześć! Twój artykuł był świetny. Dziękuję, że poprawiłeś mi ten ponury dzień 🙂</p></TextTile>
                        <TextTile><p className={body()}>Świetnie napisane, zdecydowanie zgadzam się z argumentami, które przytoczyłeś w artykule. Pozdrawiam 👋</p></TextTile>
                        <TextTile><p className={body()}>Twój punkt widzenia jest bardzo ciekawy. Spojrzałem na to z innej strony i za to dziękuję! 🙏</p></TextTile>
                        <TextTile><p className={body()}>W punkt to opisałaś! Dziękuję i pozdrawiam 🙏</p></TextTile>
                    </HeroMessages>
                </Hero>
                <QuoteSection>
                    <ShortQuote>
                        <h2 className={h2()}>"Tip the journalist" to innowacyjny model dawania napiwków za jakościowe treści w internecie. W dzisiejszych czasach "tipujemy" wszystkich, dlaczego więc napiwku nie może dostać dziennikarz za profesjonalnie napisany artykuł, podcast lub wideo?</h2>
                        <p className={p()}>Zwłaszcza że cała kwota napiwku trafi do niego jako dodatek, więc mowa tutaj naprawdę o faktycznym podziękowaniu za materiał dziennikarski.</p>
                    </ShortQuote >
                </QuoteSection>
                <Video>
                    <iframe
                        src="https://www.youtube.com/embed/aw1qIwMC1DI"
                        frameBorder={0}
                    />
                </Video>
                <QuoteSection>
                    <ShortQuote>
                        <h2 className={h2()}>Trafiłeś na poruszający reportaż? Przeczytałeś wciągający wywiad, a może wnikliwy felieton? Forma nie ma znaczenia.</h2>
                        <p className={p()}>Ważne, że od teraz możesz docenić jego autora.</p>
                    </ShortQuote >
                </QuoteSection>
                <AnimationContainer>
                    <TeamImageGrid isDesktop={isDesktop} />
                </AnimationContainer>
                <HowItWorks>
                    <CircleIcon className='svg' />
                    <h2 className={h2()}>Jak to działa?</h2>
                    <SimpleCards>
                        {
                            SimpleCardsItems.map((item) => <IconCard text={item.text} title={item.title}>{item.icon}</IconCard>)
                        }
                    </SimpleCards>
                </HowItWorks>
                <TipTestimony>
                    <TestimonyWrapper>
                        <SimpleHeader>
                            <h1 className={h1()}>Zostawisz napiwek tak, jak chcesz</h1>
                            <p className={p()}>Zostawianie napiwków jest dobrowolne, jednorazowe, a kwotę wybierasz sam. </p>
                        </SimpleHeader>
                        <TextVideo>
                            <TextVideoItem>
                                <ItemText>
                                    <h2 className={h2()}>Odwieczne pytanie ile napiwku zostawić</h2>
                                    <p className={p()}>To zależy totalnie od Ciebie, od Twojej sytuacji finansowej, nastroju i tego jak bardzo podobał Ci się artykuł. Możesz zostawić nawet złotówkę, to już wywoła uśmiech na twarzy autora. Naszym założeniem są małe, jednorazowe napiwki. Liczy sie gest!</p>
                                </ItemText>
                                <ItemVideo>
                                    <iframe src="https://www.youtube-nocookie.com/embed/_al1I8KwDE8?rel=0&modestbranding=1&showinfo=0&controls=0" frameBorder={0} width='auto'></iframe>
                                </ItemVideo>
                            </TextVideoItem>
                            <TextVideoItem>
                                <ItemVideo>
                                    <iframe src="https://www.youtube-nocookie.com/embed/B27BO2Bxvew?rel=0&modestbranding=1&showinfo=0&controls=0" frameBorder={0} width='auto'></iframe>
                                </ItemVideo>
                                <ItemText>
                                    <h2 className={h2()}>Zostaw wiadomość dla autora </h2>
                                    <p className={p()}>Zostawiając napiwek możesz zostawić spersonalizowaną wiadomość dla autora. Podziękować mu za dobry żart, albo dać znać co poruszyło Cię w jego artykule. </p>
                                </ItemText>
                            </TextVideoItem>
                        </TextVideo>
                    </TestimonyWrapper>
                </TipTestimony>
                <Faq header='Więcej o projekcie Tip The Journalist' items={faqcontent} />
                <Contacts isDesktop={isDesktop}>
                    <ContactInfo>
                        <h2 className={h2()}>Zacznij pisać dla naTemat jako autor gościnny i zarabiaj na napiwkach!</h2>
                        <p className={p()}>Chcesz zacząć pisać dla naTemat jako gościnny autor i zacząć zarabiać na napiwkach?<br />Napisz do nas!</p>
                        <ButtonWrapper><MailButton mailto='mailto:michal.mankowski@natemat.pl' label='Dowiedz się więcej' /></ButtonWrapper>
                    </ContactInfo>
                </Contacts>
            </Container>
            <Footer />
        </>
    )
}

export default ReaderTipPage;

const OrangeSpan = styled('span', {
    color: '$natematPrimary',
})

const QuoteSection = styled('div', {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    padding: '16px',
    "@bp4": {
        padding: '16px',
    }
})

const ButtonWrapper = styled('div', {
    width: '100%',
    '@bp4': {
        width: '174px',
    },
})

const SimpleHeader = styled('div', {
    width: '100%',
    color: '$grayscale100',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '24px',
    marginBottom: '56px',
    'p, h1': {
        textAlign: 'center',
        margin: 0,
    },
    '@bp4': {
        marginBottom: '96px',
    }
})



const Container = styled('div', {
    display: 'flex',
    flexDirection: 'column',
})


const Hero = styled('div', {
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
    height: '680px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    background: '$grayscale100Fixed',
    backgroundImage: `url("${dotmap}")`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'bottom center',
    padding: '16px',
    '@bp4': {
        backgroundSize: 'contain',
        flexDirection: 'row',
        justifyContent: 'center',
        paddingLeft: '84px',
        height: '600px',
    }
})

const OrangeCircle = styled('div', {
    bottom: '-30%',
    right: '50%',
    opacity: 0.2,
    filter: 'blur(200px)',
    width: '250px',
    height: '250px',
    borderRadius: '100%',
    background: '$natematPrimary',
    position: 'absolute',
    transform: 'translate(50%, -50%)',
    '@bp4': {
        filter: 'blur(250px)',
        top: '50%',
        right: '30%',
        width: '650px',
        height: '650px',
    }
})

const HeroHeader = styled('div', {
    width: '100%',
    textAlign: 'center',
    color: '$grayscale0Fixed',
    h1: {
        maxWidth: '700px',
    },
    img: {
        maxWidth: '150px',
        position: 'initial',
    },
    '@bp4': {
        img: {
            maxWidth: '250px',
            position: 'absolute',
            top: '10px',
        },
        textAlign: 'left',
        width: '50%',
    }
})

const HeroMessages = styled('div', {
    display: 'flex',
    gap: '24px',
    flexDirection: 'column',
    width: '90%',
    'div': {
        'p': {
            margin: 0,
            fontSize: '12px',
        }
    },
    'div:nth-child(1)': {
        transform: 'translateX(0px)',
    },
    'div:nth-child(2)': {
        transform: 'translateX(0px)',
    },
    'div:nth-child(3)': {
        transform: 'translateX(0px)',
    },
    'div:nth-child(4)': {
        transform: 'translateX(0px)',
    },
    '@bp4': {
        width: '40%',
        'div:nth-child(1)': {
            transform: 'translateX(50px)',
        },
        'div:nth-child(2)': {
            transform: 'translateX(100px)',
        },
        'div:nth-child(3)': {
            transform: 'translateX(0px)',
        },
        'div:nth-child(4)': {
            transform: 'translateX(75px)',
        },
    }
})

const TextTile = styled('div', {
    color: '$grayscale0Fixed',
    padding: '16px',
    borderRadius: '16px',
    width: '100%',
    background: 'rgba(255,255,255,0.07)',
    border: '1px solid rgba(255,255,255,0.12)',
    '@bp4': {
        padding: '24px',
        width: '400px',
    }
})

const ShortQuote = styled('div', {
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginTop: '40px',
    width: '320px',
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'column',
    color: '$grayscale100',
    gap: '24px',
    'h2': {
        width: '90%',
        maxWidth: '350px',
        margin: '0px',
    },
    'p': {
        fontFamily: '$charis',
        fontSize: '20px',
        lineHeight: '28px',
        margin: '0px',
        maxWidth: '300px',
    },
    '@bp4': {
        marginTop: '168px',
        width: '100%',
        maxWidth: '1440px',
        marginLeft: '84px',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        gap: '132px',
        'h2': {
            width: '60%',
            maxWidth: '730px',
        },
        'p': {
            fontFamily: '$charis',
            fontSize: '20px',
            lineHeight: '28px',
            maxWidth: '300px',
        },
    }
})

const Video = styled('div', {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '32px',
    iframe: {
        width: '100%',
        aspectRatio: 1.72,
    },
    '@bp4': {
        marginTop: '95px',
        iframe: {
            width: '90%',
            maxWidth: '1350px',
        }
    }
})

const AnimationContainer = styled('div', {
    paddingTop: '40px',
    paddingBottom: '40px',
    '@bp4': {
        paddingTop: '168px',
        paddingBottom: '168px',
    }
})

const HowItWorks = styled('div', {
    backgroundColor: '$grayscale10',
    color: '$grayscale100',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '40px',
    paddingBottom: '40px',
    gap: '0px',
    padding: '16px',
    '.svg': {
        position: 'absolute',
        zIndex: 0,
        left: 0,
        top: 0,
    },
    '@bp4': {
        paddingTop: '128px',
        paddingBottom: '144px',
        gap: '56px',

    }
})

const TipTestimony = styled('div', {
    paddingTop: '40px',
    paddingBottom: '40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    '@bp4': {
        paddingTop: '168px',
        paddingBottom: '168px',
        flexDirection: 'column',
    }
})

const TestimonyWrapper = styled('div', {
    width: '100%',
    '& > :nth-child(1)': {
        padding: '0px 16px 0px 16px',
    }
})

const TextVideo = styled('div', {
    display: 'flex',
    gap: '56px',
    justifyContent: 'center',
    flexDirection: 'column',
    '& > div:first-child': {
        flexDirection: 'column-reverse',
    },
    '@bp4': {
        gap: '128px',
        '& > div:first-child': {
            flexDirection: 'row',
        }
    }
})

const TextVideoItem = styled('div', {
    width: '100%',
    display: 'flex',
    gap: '24px',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    '@bp4': {
        flexDirection: 'row',
        gap: '128px',
    }
})

const ItemText = styled('div', {
    maxWidth: '408px',
    color: '$grayscale100',
    padding: '30px',
    p: {
        fontSize: '20px',
        lineHeight: '28px',
        margin: 0,
    }
})

const ItemVideo = styled('div', {
    width: '100%',
    aspectRatio: 1.78 / 1,
    display: 'grid',
    placeItems: 'center',
    iframe: {
        width: '100%',
        height: '100%',
    },
    '@bp4': {
        maxWidth: '512px',
        width: '40%',
        iframe: {
            width: '100%',
            height: '100%',
        }
    }
})

const ContactInfo = styled('div', {
    padding: '16px',
    paddingBottom: '40px',
    h2: {
        width: '100%',
        marginBottom: '24px',
        marginTop: '0px',
    },
    p: {
        width: '100%',
        marginBottom: '32px',
        marginTop: '0px',
    },
    '@bp4': {
        width: '480px',
        marginLeft: '84px',
        padding: '0px',
        span: {
            fontWeight: '400 !important'
        }
    }
})
